// Recovered compiled webpack factory 68894. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { u: () => s });
  var n = i(31739);
  let s = {
    test: (0, i(23919).$)("#"),
    parse: function (t) {
      let e = "",
        i = "",
        n = "",
        s = "";
      return (
        t.length > 5
          ? ((e = t.substring(1, 3)),
            (i = t.substring(3, 5)),
            (n = t.substring(5, 7)),
            (s = t.substring(7, 9)))
          : ((e = t.substring(1, 2)),
            (i = t.substring(2, 3)),
            (n = t.substring(3, 4)),
            (s = t.substring(4, 5)),
            (e += e),
            (i += i),
            (n += n),
            (s += s)),
        {
          red: parseInt(e, 16),
          green: parseInt(i, 16),
          blue: parseInt(n, 16),
          alpha: s ? parseInt(s, 16) / 255 : 1,
        }
      );
    },
    transform: n.B.transform,
  };
}
